import React, { useRef } from 'react';
import TableSkeleton from '../../BaseComponents/TableSkeleton';
import NotesTableRow from './NotesTableRow';
import { NoteResponse } from '../../../api/notes';
import './NotesTable.scss';
import downArrow from '../../../assets/icons/downArrow.png';

interface NotesTableProps {
  notesList: NoteResponse[];
  isLoading: boolean;
  sortingLoading: boolean;
  onViewNote: (note: NoteResponse, forceViewOnly?: boolean) => void;
  onEditNote: (note: NoteResponse) => void;
  onDeleteNote: (noteId: number) => void;
  onSort: (field: string) => void;
  isReadOnly?: boolean;
}

const NotesTable: React.FC<NotesTableProps> = ({
  notesList,
  isLoading,
  sortingLoading,
  onViewNote,
  onEditNote,
  onDeleteNote,
  onSort,
  isReadOnly = false,
}) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  if (isLoading) {
    return (
      <div className='notes-container'>
        <div className='notes-table-scroll'>
          <div className='notes-table'>
            <div className='table-header'>
            <div className='header-cell'>Created at <img src={downArrow} alt="" style={{ cursor: 'pointer' }} onClick={() => onSort('created_at')} /></div>
            <div className='header-cell'>Updated at <img src={downArrow} alt="" style={{ cursor: 'pointer' }} onClick={() => onSort('updated_at')} /></div>
            <div className='header-cell'>Note</div>
            <div className='header-cell'>Created by</div>
            <div className='header-cell'>Visibility</div>
            <div className='header-cell'>Category</div>
            <div className='header-cell'>View</div>
            <div className='header-cell'></div>
          </div>
          <div className='table-body' ref={scrollContainerRef}>
            <div className='loading-state'>
              <div className='loading-spinner'></div>
              <div className='loading-text'>Loading notes...</div>
            </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='notes-container'>
      <div className='notes-table-scroll'>
        <div className='notes-table'>
          <div className='table-header'>
          <div className='header-cell'>Created at <img src={downArrow} alt="" style={{ cursor: 'pointer' }} onClick={() => onSort('created_at')} /></div>
          <div className='header-cell'>Updated at <img src={downArrow} alt="" style={{ cursor: 'pointer' }} onClick={() => onSort('updated_at')} /></div>
          <div className='header-cell'>Note</div>
          <div className='header-cell'>Created by</div>
          <div className='header-cell'>Visibility</div>
          <div className='header-cell'>Category</div>
          <div className='header-cell'>View</div>
          <div className='header-cell'></div>
        </div>
        <div className='table-body' ref={scrollContainerRef}>
          {sortingLoading ? (
            <TableSkeleton rows={5} columns={5} />
          ) : notesList?.length > 0 ? (
            notesList.map((note) => (
              <NotesTableRow
                noteData={note}
                key={note.id}
                onViewNote={onViewNote}
                onEditNote={onEditNote}
                onDeleteNote={onDeleteNote}
                isReadOnly={isReadOnly}
              />
            ))
          ) : (
            <div className='empty-state'>
              <div className='empty-text'>No notes found</div>
              <div className='empty-subtext'>Click "Add note" to create your first note.</div>
            </div>
          )}
        </div>
        </div>
      </div>
    </div>
  );
};

export default NotesTable;
